import React, {Component} from 'react';
import AddFunds from "./addFunds/AddFunds";


class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            planPeriod: true,
            chosenPlan: 'essentials'
        }
    }


    componentDidMount() {
        let col1row1 = document.querySelector(' #features .feature:nth-of-type(1)')
        let col2row1 = document.querySelector(' #enterprise .feature:nth-of-type(1)')
        let col3row1 = document.querySelector(' #premium .feature:nth-of-type(1)')
        let col4row1 = document.querySelector(' #essentials .feature:nth-of-type(1)')
        let col5row1 = document.querySelector(' #free .feature:nth-of-type(1)')

        col1row1.addEventListener('mouseover', () => this.hover(1), false)
        col1row1.addEventListener('mouseout', () => this.hoverOut(1), false)
        col2row1.addEventListener('mouseover', () => this.hover(1), false)
        col2row1.addEventListener('mouseout', () => this.hoverOut(1), false)
        col3row1.addEventListener('mouseover', () => this.hover(1), false)
        col3row1.addEventListener('mouseout', () => this.hoverOut(1), false)
        col4row1.addEventListener('mouseover', () => this.hover(1), false)
        col4row1.addEventListener('mouseout', () => this.hoverOut(1), false)
        col5row1.addEventListener('mouseover', () => this.hover(1), false)
        col5row1.addEventListener('mouseout', () => this.hoverOut(1), false)

        let col1row2 = document.querySelector(' #features .feature:nth-of-type(2)')
        let col2row2 = document.querySelector(' #enterprise .feature:nth-of-type(2)')
        let col3row2 = document.querySelector(' #premium .feature:nth-of-type(2)')
        let col4row2 = document.querySelector(' #essentials .feature:nth-of-type(2)')
        let col5row2 = document.querySelector(' #free .feature:nth-of-type(2)')

        col1row2.addEventListener('mouseover', () => this.hover(2), false)
        col1row2.addEventListener('mouseout', () => this.hoverOut(2), false)
        col2row2.addEventListener('mouseover', () => this.hover(2), false)
        col2row2.addEventListener('mouseout', () => this.hoverOut(2), false)
        col3row2.addEventListener('mouseover', () => this.hover(2), false)
        col3row2.addEventListener('mouseout', () => this.hoverOut(2), false)
        col4row2.addEventListener('mouseover', () => this.hover(2), false)
        col4row2.addEventListener('mouseout', () => this.hoverOut(2), false)
        col5row2.addEventListener('mouseover', () => this.hover(2), false)
        col5row2.addEventListener('mouseout', () => this.hoverOut(2), false)

        let col1row3 = document.querySelector(' #features .feature:nth-of-type(3)')
        let col2row3 = document.querySelector(' #enterprise .feature:nth-of-type(3)')
        let col3row3 = document.querySelector(' #premium .feature:nth-of-type(3)')
        let col4row3 = document.querySelector(' #essentials .feature:nth-of-type(3)')
        let col5row3 = document.querySelector(' #free .feature:nth-of-type(3)')

        col1row3.addEventListener('mouseover', () => this.hover(3), false)
        col1row3.addEventListener('mouseout', () => this.hoverOut(3), false)
        col2row3.addEventListener('mouseover', () => this.hover(3), false)
        col2row3.addEventListener('mouseout', () => this.hoverOut(3), false)
        col3row3.addEventListener('mouseover', () => this.hover(3), false)
        col3row3.addEventListener('mouseout', () => this.hoverOut(3), false)
        col4row3.addEventListener('mouseover', () => this.hover(3), false)
        col4row3.addEventListener('mouseout', () => this.hoverOut(3), false)
        col5row3.addEventListener('mouseover', () => this.hover(3), false)
        col5row3.addEventListener('mouseout', () => this.hoverOut(3), false)

        let col1row4 = document.querySelector(' #features .feature:nth-of-type(4)')
        let col2row4 = document.querySelector(' #enterprise .feature:nth-of-type(4)')
        let col3row4 = document.querySelector(' #premium .feature:nth-of-type(4)')
        let col4row4 = document.querySelector(' #essentials .feature:nth-of-type(4)')
        let col5row4 = document.querySelector(' #free .feature:nth-of-type(4)')

        col1row4.addEventListener('mouseover', () => this.hover(4), false)
        col1row4.addEventListener('mouseout', () => this.hoverOut(4), false)
        col2row4.addEventListener('mouseover', () => this.hover(4), false)
        col2row4.addEventListener('mouseout', () => this.hoverOut(4), false)
        col3row4.addEventListener('mouseover', () => this.hover(4), false)
        col3row4.addEventListener('mouseout', () => this.hoverOut(4), false)
        col4row4.addEventListener('mouseover', () => this.hover(4), false)
        col4row4.addEventListener('mouseout', () => this.hoverOut(4), false)
        col5row4.addEventListener('mouseover', () => this.hover(4), false)
        col5row4.addEventListener('mouseout', () => this.hoverOut(4), false)

        let col1row5 = document.querySelector(' #features .feature:nth-of-type(5)')
        let col2row5 = document.querySelector(' #enterprise .feature:nth-of-type(5)')
        let col3row5 = document.querySelector(' #premium .feature:nth-of-type(5)')
        let col4row5 = document.querySelector(' #essentials .feature:nth-of-type(5)')
        let col5row5 = document.querySelector(' #free .feature:nth-of-type(5)')

        col1row5.addEventListener('mouseover', () => this.hover(5), false)
        col1row5.addEventListener('mouseout', () => this.hoverOut(5), false)
        col2row5.addEventListener('mouseover', () => this.hover(5), false)
        col2row5.addEventListener('mouseout', () => this.hoverOut(5), false)
        col3row5.addEventListener('mouseover', () => this.hover(5), false)
        col3row5.addEventListener('mouseout', () => this.hoverOut(5), false)
        col4row5.addEventListener('mouseover', () => this.hover(5), false)
        col4row5.addEventListener('mouseout', () => this.hoverOut(5), false)
        col5row5.addEventListener('mouseover', () => this.hover(5), false)
        col5row5.addEventListener('mouseout', () => this.hoverOut(5), false)

        let col1row6 = document.querySelector(' #features .feature:nth-of-type(6)')
        let col2row6 = document.querySelector(' #enterprise .feature:nth-of-type(6)')
        let col3row6 = document.querySelector(' #premium .feature:nth-of-type(6)')
        let col4row6 = document.querySelector(' #essentials .feature:nth-of-type(6)')
        let col5row6 = document.querySelector(' #free .feature:nth-of-type(6)')

        col1row6.addEventListener('mouseover', () => this.hover(6), false)
        col1row6.addEventListener('mouseout', () => this.hoverOut(6), false)
        col2row6.addEventListener('mouseover', () => this.hover(6), false)
        col2row6.addEventListener('mouseout', () => this.hoverOut(6), false)
        col3row6.addEventListener('mouseover', () => this.hover(6), false)
        col3row6.addEventListener('mouseout', () => this.hoverOut(6), false)
        col4row6.addEventListener('mouseover', () => this.hover(6), false)
        col4row6.addEventListener('mouseout', () => this.hoverOut(6), false)
        col5row6.addEventListener('mouseover', () => this.hover(6), false)
        col5row6.addEventListener('mouseout', () => this.hoverOut(6), false)

        let col1row7 = document.querySelector(' #features .feature:nth-of-type(7)')
        let col2row7 = document.querySelector(' #enterprise .feature:nth-of-type(7)')
        let col3row7 = document.querySelector(' #premium .feature:nth-of-type(7)')
        let col4row7 = document.querySelector(' #essentials .feature:nth-of-type(7)')
        let col5row7 = document.querySelector(' #free .feature:nth-of-type(7)')

        col1row7.addEventListener('mouseover', () => this.hover(7), false)
        col1row7.addEventListener('mouseout', () => this.hoverOut(7), false)
        col2row7.addEventListener('mouseover', () => this.hover(7), false)
        col2row7.addEventListener('mouseout', () => this.hoverOut(7), false)
        col3row7.addEventListener('mouseover', () => this.hover(7), false)
        col3row7.addEventListener('mouseout', () => this.hoverOut(7), false)
        col4row7.addEventListener('mouseover', () => this.hover(7), false)
        col4row7.addEventListener('mouseout', () => this.hoverOut(7), false)
        col5row7.addEventListener('mouseover', () => this.hover(7), false)
        col5row7.addEventListener('mouseout', () => this.hoverOut(7), false)

        let col1row8 = document.querySelector(' #features .feature:nth-of-type(8)')
        let col2row8 = document.querySelector(' #enterprise .feature:nth-of-type(8)')
        let col3row8 = document.querySelector(' #premium .feature:nth-of-type(8)')
        let col4row8 = document.querySelector(' #essentials .feature:nth-of-type(8)')
        let col5row8 = document.querySelector(' #free .feature:nth-of-type(8)')

        col1row8.addEventListener('mouseover', () => this.hover(8), false)
        col1row8.addEventListener('mouseout', () => this.hoverOut(8), false)
        col2row8.addEventListener('mouseover', () => this.hover(8), false)
        col2row8.addEventListener('mouseout', () => this.hoverOut(8), false)
        col3row8.addEventListener('mouseover', () => this.hover(8), false)
        col3row8.addEventListener('mouseout', () => this.hoverOut(8), false)
        col4row8.addEventListener('mouseover', () => this.hover(8), false)
        col4row8.addEventListener('mouseout', () => this.hoverOut(8), false)
        col5row8.addEventListener('mouseover', () => this.hover(8), false)
        col5row8.addEventListener('mouseout', () => this.hoverOut(8), false)

        let col1row9 = document.querySelector(' #features .feature:nth-of-type(9)')
        let col2row9 = document.querySelector(' #enterprise .feature:nth-of-type(9)')
        let col3row9 = document.querySelector(' #premium .feature:nth-of-type(9)')
        let col4row9 = document.querySelector(' #essentials .feature:nth-of-type(9)')
        let col5row9 = document.querySelector(' #free .feature:nth-of-type(9)')

        col1row9.addEventListener('mouseover', () => this.hover(9), false)
        col1row9.addEventListener('mouseout', () => this.hoverOut(9), false)
        col2row9.addEventListener('mouseover', () => this.hover(9), false)
        col2row9.addEventListener('mouseout', () => this.hoverOut(9), false)
        col3row9.addEventListener('mouseover', () => this.hover(9), false)
        col3row9.addEventListener('mouseout', () => this.hoverOut(9), false)
        col4row9.addEventListener('mouseover', () => this.hover(9), false)
        col4row9.addEventListener('mouseout', () => this.hoverOut(9), false)
        col5row9.addEventListener('mouseover', () => this.hover(9), false)
        col5row9.addEventListener('mouseout', () => this.hoverOut(9), false)

        let col1row10 = document.querySelector(' #features .feature:nth-of-type(10)')
        let col2row10 = document.querySelector(' #enterprise .feature:nth-of-type(10)')
        let col3row10 = document.querySelector(' #premium .feature:nth-of-type(10)')
        let col4row10 = document.querySelector(' #essentials .feature:nth-of-type(10)')
        let col5row10 = document.querySelector(' #free .feature:nth-of-type(10)')

        col1row10.addEventListener('mouseover', () => this.hover(10), false)
        col1row10.addEventListener('mouseout', () => this.hoverOut(10), false)
        col2row10.addEventListener('mouseover', () => this.hover(10), false)
        col2row10.addEventListener('mouseout', () => this.hoverOut(10), false)
        col3row10.addEventListener('mouseover', () => this.hover(10), false)
        col3row10.addEventListener('mouseout', () => this.hoverOut(10), false)
        col4row10.addEventListener('mouseover', () => this.hover(10), false)
        col4row10.addEventListener('mouseout', () => this.hoverOut(10), false)
        col5row10.addEventListener('mouseover', () => this.hover(10), false)
        col5row10.addEventListener('mouseout', () => this.hoverOut(10), false)

        let col1row11 = document.querySelector(' #features .feature:nth-of-type(11)')
        let col2row11 = document.querySelector(' #enterprise .feature:nth-of-type(11)')
        let col3row11 = document.querySelector(' #premium .feature:nth-of-type(11)')
        let col4row11 = document.querySelector(' #essentials .feature:nth-of-type(11)')
        let col5row11 = document.querySelector(' #free .feature:nth-of-type(11)')

        col1row11.addEventListener('mouseover', () => this.hover(11), false)
        col1row11.addEventListener('mouseout', () => this.hoverOut(11), false)
        col2row11.addEventListener('mouseover', () => this.hover(11), false)
        col2row11.addEventListener('mouseout', () => this.hoverOut(11), false)
        col3row11.addEventListener('mouseover', () => this.hover(11), false)
        col3row11.addEventListener('mouseout', () => this.hoverOut(11), false)
        col4row11.addEventListener('mouseover', () => this.hover(11), false)
        col4row11.addEventListener('mouseout', () => this.hoverOut(11), false)
        col5row11.addEventListener('mouseover', () => this.hover(11), false)
        col5row11.addEventListener('mouseout', () => this.hoverOut(11), false)

        let col1row12 = document.querySelector(' #features .feature:nth-of-type(12)')
        let col2row12 = document.querySelector(' #enterprise .feature:nth-of-type(12)')
        let col3row12 = document.querySelector(' #premium .feature:nth-of-type(12)')
        let col4row12 = document.querySelector(' #essentials .feature:nth-of-type(12)')
        let col5row12 = document.querySelector(' #free .feature:nth-of-type(12)')

        col1row12.addEventListener('mouseover', () => this.hover(12), false)
        col1row12.addEventListener('mouseout', () => this.hoverOut(12), false)
        col2row12.addEventListener('mouseover', () => this.hover(12), false)
        col2row12.addEventListener('mouseout', () => this.hoverOut(12), false)
        col3row12.addEventListener('mouseover', () => this.hover(12), false)
        col3row12.addEventListener('mouseout', () => this.hoverOut(12), false)
        col4row12.addEventListener('mouseover', () => this.hover(12), false)
        col4row12.addEventListener('mouseout', () => this.hoverOut(12), false)
        col5row12.addEventListener('mouseover', () => this.hover(12), false)
        col5row12.addEventListener('mouseout', () => this.hoverOut(12), false)

        let col1row13 = document.querySelector(' #features .feature:nth-of-type(13)')
        let col2row13 = document.querySelector(' #enterprise .feature:nth-of-type(13)')
        let col3row13 = document.querySelector(' #premium .feature:nth-of-type(13)')
        let col4row13 = document.querySelector(' #essentials .feature:nth-of-type(13)')
        let col5row13 = document.querySelector(' #free .feature:nth-of-type(13)')

        col1row13.addEventListener('mouseover', () => this.hover(13), false)
        col1row13.addEventListener('mouseout', () => this.hoverOut(13), false)
        col2row13.addEventListener('mouseover', () => this.hover(13), false)
        col2row13.addEventListener('mouseout', () => this.hoverOut(13), false)
        col3row13.addEventListener('mouseover', () => this.hover(13), false)
        col3row13.addEventListener('mouseout', () => this.hoverOut(13), false)
        col4row13.addEventListener('mouseover', () => this.hover(13), false)
        col4row13.addEventListener('mouseout', () => this.hoverOut(13), false)
        col5row13.addEventListener('mouseover', () => this.hover(13), false)
        col5row13.addEventListener('mouseout', () => this.hoverOut(13), false)

        let col1row14 = document.querySelector(' #features .feature:nth-of-type(14)')
        let col2row14 = document.querySelector(' #enterprise .feature:nth-of-type(14)')
        let col3row14 = document.querySelector(' #premium .feature:nth-of-type(14)')
        let col4row14 = document.querySelector(' #essentials .feature:nth-of-type(14)')
        let col5row14 = document.querySelector(' #free .feature:nth-of-type(14)')

        col1row14.addEventListener('mouseover', () => this.hover(14), false)
        col1row14.addEventListener('mouseout', () => this.hoverOut(14), false)
        col2row14.addEventListener('mouseover', () => this.hover(14), false)
        col2row14.addEventListener('mouseout', () => this.hoverOut(14), false)
        col3row14.addEventListener('mouseover', () => this.hover(14), false)
        col3row14.addEventListener('mouseout', () => this.hoverOut(14), false)
        col4row14.addEventListener('mouseover', () => this.hover(14), false)
        col4row14.addEventListener('mouseout', () => this.hoverOut(14), false)
        col5row14.addEventListener('mouseover', () => this.hover(14), false)
        col5row14.addEventListener('mouseout', () => this.hoverOut(14), false)

        let col1row15 = document.querySelector(' #features .feature:nth-of-type(15)')
        let col2row15 = document.querySelector(' #enterprise .feature:nth-of-type(15)')
        let col3row15 = document.querySelector(' #premium .feature:nth-of-type(15)')
        let col4row15 = document.querySelector(' #essentials .feature:nth-of-type(15)')
        let col5row15 = document.querySelector(' #free .feature:nth-of-type(15)')

        col1row15.addEventListener('mouseover', () => this.hover(15), false)
        col1row15.addEventListener('mouseout', () => this.hoverOut(15), false)
        col2row15.addEventListener('mouseover', () => this.hover(15), false)
        col2row15.addEventListener('mouseout', () => this.hoverOut(15), false)
        col3row15.addEventListener('mouseover', () => this.hover(15), false)
        col3row15.addEventListener('mouseout', () => this.hoverOut(15), false)
        col4row15.addEventListener('mouseover', () => this.hover(15), false)
        col4row15.addEventListener('mouseout', () => this.hoverOut(15), false)
        col5row15.addEventListener('mouseover', () => this.hover(15), false)
        col5row15.addEventListener('mouseout', () => this.hoverOut(15), false)

        let col1row16 = document.querySelector(' #features .feature:nth-of-type(16)')
        let col2row16 = document.querySelector(' #enterprise .feature:nth-of-type(16)')
        let col3row16 = document.querySelector(' #premium .feature:nth-of-type(16)')
        let col4row16 = document.querySelector(' #essentials .feature:nth-of-type(16)')
        let col5row16 = document.querySelector(' #free .feature:nth-of-type(16)')

        col1row16.addEventListener('mouseover', () => this.hover(16), false)
        col1row16.addEventListener('mouseout', () => this.hoverOut(16), false)
        col2row16.addEventListener('mouseover', () => this.hover(16), false)
        col2row16.addEventListener('mouseout', () => this.hoverOut(16), false)
        col3row16.addEventListener('mouseover', () => this.hover(16), false)
        col3row16.addEventListener('mouseout', () => this.hoverOut(16), false)
        col4row16.addEventListener('mouseover', () => this.hover(16), false)
        col4row16.addEventListener('mouseout', () => this.hoverOut(16), false)
        col5row16.addEventListener('mouseover', () => this.hover(16), false)
        col5row16.addEventListener('mouseout', () => this.hoverOut(16), false)

        let col1row17 = document.querySelector(' #features .feature:nth-of-type(17)')
        let col2row17 = document.querySelector(' #enterprise .feature:nth-of-type(17)')
        let col3row17 = document.querySelector(' #premium .feature:nth-of-type(17)')
        let col4row17 = document.querySelector(' #essentials .feature:nth-of-type(17)')
        let col5row17 = document.querySelector(' #free .feature:nth-of-type(17)')

        col1row17.addEventListener('mouseover', () => this.hover(17), false)
        col1row17.addEventListener('mouseout', () => this.hoverOut(17), false)
        col2row17.addEventListener('mouseover', () => this.hover(17), false)
        col2row17.addEventListener('mouseout', () => this.hoverOut(17), false)
        col3row17.addEventListener('mouseover', () => this.hover(17), false)
        col3row17.addEventListener('mouseout', () => this.hoverOut(17), false)
        col4row17.addEventListener('mouseover', () => this.hover(17), false)
        col4row17.addEventListener('mouseout', () => this.hoverOut(17), false)
        col5row17.addEventListener('mouseover', () => this.hover(17), false)
        col5row17.addEventListener('mouseout', () => this.hoverOut(17), false)

        let col1row18 = document.querySelector(' #features .feature:nth-of-type(18)')
        let col2row18 = document.querySelector(' #enterprise .feature:nth-of-type(18)')
        let col3row18 = document.querySelector(' #premium .feature:nth-of-type(18)')
        let col4row18 = document.querySelector(' #essentials .feature:nth-of-type(18)')
        let col5row18 = document.querySelector(' #free .feature:nth-of-type(18)')

        col1row18.addEventListener('mouseover', () => this.hover(18), false)
        col1row18.addEventListener('mouseout', () => this.hoverOut(18), false)
        col2row18.addEventListener('mouseover', () => this.hover(18), false)
        col2row18.addEventListener('mouseout', () => this.hoverOut(18), false)
        col3row18.addEventListener('mouseover', () => this.hover(18), false)
        col3row18.addEventListener('mouseout', () => this.hoverOut(18), false)
        col4row18.addEventListener('mouseover', () => this.hover(18), false)
        col4row18.addEventListener('mouseout', () => this.hoverOut(18), false)
        col5row18.addEventListener('mouseover', () => this.hover(18), false)
        col5row18.addEventListener('mouseout', () => this.hoverOut(18), false)

        let col1row19 = document.querySelector(' #features .feature:nth-of-type(19)')
        let col2row19 = document.querySelector(' #enterprise .feature:nth-of-type(19)')
        let col3row19 = document.querySelector(' #premium .feature:nth-of-type(19)')
        let col4row19 = document.querySelector(' #essentials .feature:nth-of-type(19)')
        let col5row19 = document.querySelector(' #free .feature:nth-of-type(19)')

        col1row19.addEventListener('mouseover', () => this.hover(19), false)
        col1row19.addEventListener('mouseout', () => this.hoverOut(19), false)
        col2row19.addEventListener('mouseover', () => this.hover(19), false)
        col2row19.addEventListener('mouseout', () => this.hoverOut(19), false)
        col3row19.addEventListener('mouseover', () => this.hover(19), false)
        col3row19.addEventListener('mouseout', () => this.hoverOut(19), false)
        col4row19.addEventListener('mouseover', () => this.hover(19), false)
        col4row19.addEventListener('mouseout', () => this.hoverOut(19), false)
        col5row19.addEventListener('mouseover', () => this.hover(19), false)
        col5row19.addEventListener('mouseout', () => this.hoverOut(19), false)

        let col1row20 = document.querySelector(' #features .feature:nth-of-type(20)')
        let col2row20 = document.querySelector(' #enterprise .feature:nth-of-type(20)')
        let col3row20 = document.querySelector(' #premium .feature:nth-of-type(20)')
        let col4row20 = document.querySelector(' #essentials .feature:nth-of-type(20)')
        let col5row20 = document.querySelector(' #free .feature:nth-of-type(20)')

        col1row20.addEventListener('mouseover', () => this.hover(20), false)
        col1row20.addEventListener('mouseout', () => this.hoverOut(20), false)
        col2row20.addEventListener('mouseover', () => this.hover(20), false)
        col2row20.addEventListener('mouseout', () => this.hoverOut(20), false)
        col3row20.addEventListener('mouseover', () => this.hover(20), false)
        col3row20.addEventListener('mouseout', () => this.hoverOut(20), false)
        col4row20.addEventListener('mouseover', () => this.hover(20), false)
        col4row20.addEventListener('mouseout', () => this.hoverOut(20), false)
        col5row20.addEventListener('mouseover', () => this.hover(20), false)
        col5row20.addEventListener('mouseout', () => this.hoverOut(20), false)
    }

    hover = (n) => {
        document.querySelector('#features .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        document.querySelector('#enterprise .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        document.querySelector('#premium .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        document.querySelector('#essentials .feature:nth-of-type(' + n + ')').style.backgroundColor = '#3695DD';
        document.querySelector('#free .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
    }

    hoverOut(n) {

        document.querySelector('#features .feature:nth-of-type(' + n + ')').style.backgroundColor = 'white';
        document.querySelector('#enterprise .feature:nth-of-type(' + n + ')').style.backgroundColor = 'white';
        document.querySelector('#premium .feature:nth-of-type(' + n + ')').style.backgroundColor = '#F5FBFE';
        document.querySelector('#essentials .feature:nth-of-type(' + n + ')').style.backgroundColor = '#3AAAE1';
        document.querySelector('#free .feature:nth-of-type(' + n + ')').style.backgroundColor = 'white';
    }


    togglePlanPeriod = async () => {
        let planPeriod = await !this.state.planPeriod
        await this.setState({
            planPeriod
        })

    }

    planPeriodToggle = async () => {
        if (this.state.planPeriod === true) {
            await this.setState({planPeriod: false});
        } else {
            await this.setState({planPeriod: true});

        }
        setTimeout(this.checkTrue, 300)

    }
    selectPlan = (plan) => {

        this.setState({
            chosenPlan: plan
        })
    }
    checkTrue = async () => {
        //console.log('yearly')

        if (this.state.planPeriod === true) {

            if (document.querySelector('#premium .yearly-label')) {
                document.querySelector('#premium .yearly-label').style.opacity = '1'
            }
            if (document.querySelector('#premium-mobile .yearly-label')) {
                document.querySelector('#premium-mobile .yearly-label').style.opacity = '1'
            }
            if (document.querySelector('#essentials .yearly-label')) {
                document.querySelector('#essentials .yearly-label').style.opacity = '1'
            }
            if (document.querySelector('#essentials-mobile .yearly-label')) {
                document.querySelector('#essentials-mobile .yearly-label').style.opacity = '1'
            }

        } else {

            if (document.querySelector('#premium .yearly-label')) {
                document.querySelector('#premium .yearly-label').style.opacity = '0'
            }
            if (document.querySelector('#premium-mobile .yearly-label')) {
                document.querySelector('#premium-mobile .yearly-label').style.opacity = '0'
            }
            if (document.querySelector('#essentials .yearly-label')) {
                document.querySelector('#essentials .yearly-label').style.opacity = '0'
            }
            if (document.querySelector('#essentials-mobile .yearly-label')) {
                document.querySelector('#essentials-mobile .yearly-label').style.opacity = '0'
            }
        }
    }

    render() {
        return (
            <div className='pricing-wrapper text-center'>
                <div className="choose-period">
                    <div className="switch-container">
                        <span>Monthly</span>
                        <label className="plan-switch" htmlFor="checkbox-2">
                            <input
                                checked={this.state.planPeriod}

                                onClick={this.planPeriodToggle} type="checkbox"
                                id="checkbox-2"/>
                            <div className="plan-slider plan-round"></div>
                        </label>
                        <span>Yearly</span>
                    </div>
                </div>
                <div id="big-screen">
                    <div className="plans-container">
                        <div id='features'>
                            <div className="feature-rows">
                                <div className="feature first-row"><i className="fas fa-check"></i>All Channels</div>
                                <div className="feature feature-sms"><i className="fas fa-comment-dots"></i>SMS</div>
                                <div className="feature feature-viber"><i className="fab fa-viber"></i>Viber</div>
                                <div className="feature feature-webpush"><i className="fas fa-bell"></i>Web Push</div>
                                <div className="feature feature-messenger"><i className="fab fa-facebook-messenger"></i>Messenger
                                </div>
                                <div className="feature"><i className="fas fa-user-check"></i>Contacts & Subscribers
                                </div>
                                <div className="feature"><i className="fas fa-user-friends"></i>Team Members</div>
                                <div className="feature"><i className="fas fa-chart-pie"></i>Detailed Analytics</div>
                                <div className="feature"><i className="fas fa-ad"></i>Ads Manager
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Create Facebook Messenger Subscriber Acquisition Campaign right from Emitto. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fab fa-wordpress"></i>WordPress Plugin
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Get started with Web Push Notifications in minutes by simply installing Emitto Plugin on your website. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-tag"></i>Audience Segmentation
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Segment your audience by their demographics or interests in details, such are the country they are from, gender or consumer habits. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-fingerprint"></i>Personalized Messages
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Personalize your messages by using tags such are 'First Name', 'Last Name' or 'Company'. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-history"></i>Recorded History</div>
                                <div className="feature"><i className="fas fa-link"></i>URL Shortener
                                </div>
                                <div className="feature"><i className="fas fa-compress"></i>Content Curation
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Accumulate newly published content from multiple sources and send them to your audience with one click. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-magic"></i>Automations
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">RSS to Web Push - Zero-click Automation. </span></div>
                                </div>
                                <div className="feature"><i className="fas fa-clipboard-check"></i>Branding Removal
                                </div>
                                <div className="feature"><i className="fas fa-map-signs"></i>Dedicated Onboarding
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">A session with a team of professionals to get you started with Emitto and take advantage of all the features. </span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-child"></i>Account Manager</div>
                                <div className="feature"><i className="fas fa-percentage"></i>Volume Discounts</div>
                            </div>
                        </div>
                        <div id="enterprise" className='plan'>
                            <h2 className="title">Enterprise</h2>
                            <div className="price-container">
                                <div className="price-container">
                                    <div className="plan-price">
                                        Contact us
                                    </div>
                                </div>
                            </div>
                            <div className="feature-rows">
                                <div className="feature first-row"><i className="fas fa-check"></i></div>
                                <div className="feature">
                                    <span className='text-bold'>
                                        <span
                                            className='text-green'>{"<"}
                                        </span>$ 0.0132
                                    </span>
                                    <span className='price-list'>per SMS (US)
                                    </span>
                                </div>
                                <div className="feature">
                                    <span className='text-bold'><span
                                        className='text-green'>{"<"}</span>$ 0.0039</span>
                                    <span className='price-list'>per Message (US)</span>

                                </div>
                                <div className="feature">
                                    <span className='text-bold'><span className='text-bold'><span
                                        className='text-green'>{"<"}</span> $ 0.7</span>
                                    </span>
                                    <span className='price-list'>per 1000 Notifications</span>
                                </div>
                                <div className="feature">
                                    <span className='text-bold'><span className='text-bold'>
                                        <span className='text-green'>{"<"}</span> $ 2.1</span>
                                    </span>
                                    <span className='price-list'>per 1000 Notifications</span>
                                </div>
                                <div className="feature">Unlimited</div>
                                <div className="feature">Unlimited</div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature">1+ Year</div>
                                <div className="feature">Fully Featured
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Includes unlimited shortened links with customized domain and UTM tagging option. </span>
                                    </div>
                                </div>
                                <div className="feature">10+ Content Sources</div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature">60+ min</div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                            </div>
                            <button className='plan-button'>
                                Get in touch
                            </button>
                        </div>
                        <div id='premium' className="plan">
                            <h2 className="title">
                                Premium
                            </h2>
                            <div className="price-container">
                                <div className="plan-price">
                                    <div className="yearly-label">
                                        billed annually
                                    </div>
                                    <span className='currency'>$</span><span className='price'>{this.state.planPeriod === true ? 75 : 89}</span>
                                    <span className='plan-period'>/month</span>
                                </div>
                                <div className="feature-rows">
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature">
                                        <span className='text-bold'>
                                            $ 0.0132
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>per SMS (US)</span>
                                    </div>
                                    <div className="feature">
                                       <span className='text-bold'>
                                            $ 0.0039
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>per Message (US)</span>
                                    </div>
                                    <div className="feature">
                                        <span className='text-bold'>
                                            $ 0.7
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>per 1000 Notifications</span>
                                    </div>
                                    <div className="feature">
                                        <span className='text-bold'>
                                            $ 2.1
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>Per 1000 Messages sent</span>
                                    </div>
                                    <div className="feature">Unlimited</div>
                                    <div className="feature">Unlimited</div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature">6 Months</div>
                                    <div className="feature">Advanced
                                        <div className="tooltip"> ? <span
                                            className="tooltiptext">Includes unlimited shortened links with UTM tagging option. </span>
                                        </div>
                                    </div>
                                    <div className="feature">10 Content Sources</div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature">30 min</div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                </div>
                                <button className='plan-button'>
                                    Start 7 days trial
                                </button>
                            </div>
                        </div>
                        <div id='essentials' className="plan">
                            <img src="img/ribbon.png" className='ribbon' alt="Emitto recommended"/>
                            <h2 className="title">
                                Essentials
                            </h2>
                            <div className="price-container">
                                <div className="plan-price">
                                    <div className="yearly-label">
                                        billed annually
                                    </div>
                                    <span className='currency'>$</span><span className='price'>{this.state.planPeriod === true ? 41 : 49}</span>
                                    <span className='plan-period'>/month</span>
                                </div>
                                <div className="feature-rows">
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature">
                                      <span className='text-bold'>
                                            $ 0.0139
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>per SMS (US)</span>
                                    </div>
                                    <div className="feature">
                                         <span className='text-bold'>
                                            $ 0.0042
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>per Message (US)</span>
                                    </div>
                                    <div className="feature">
                                         <span className='text-bold'>
                                            $ 0.8
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>Per 1000 Notifications</span>
                                    </div>
                                    <div className="feature text-center">
                                        <span className='text-bold'>
                                            $ 2.4
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                        <span className='price-list'>Per 1000 Messages sent</span>
                                    </div>
                                    <div className="feature">Unlimited</div>
                                    <div className="feature">Unlimited</div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                    <div className="feature">4 Months</div>
                                    <div className="feature">Basic
                                        <div className="tooltip"> ? <span
                                            className="tooltiptext">Includes 100 shortened links for individual link analytics and performance across all channels in real-time.</span>
                                        </div>
                                    </div>
                                    <div className="feature">1 Content Source</div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                    <div className="feature"><i className="fas fa-check"></i></div>
                                    <div className="feature">
                                        <span className="green-label">promo</span>
                                        30 min
                                    </div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                    <div className="feature"><i className="fas fa-times"></i></div>
                                </div>
                                <button className='plan-button'>
                                    Start 7 days trial
                                </button>
                            </div>
                        </div>
                        <div id='free' className="plan">
                            <h2 className="title">
                                Free
                            </h2>
                            <div className="price-container">
                                <div className="plan-price">
                                    <span className='currency'>$</span><span className='price'>0</span>
                                    <span className='plan-period'>/month</span>
                                </div>
                            </div>
                            <div className="feature-rows">
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature">
                                   <span className='text-bold'>
                                            $ 0.0149
                                        </span>
                                    <span className='price-list'>per SMS (US)</span>
                                </div>
                                <div className="feature">
                                   <span className='text-bold'>
                                       $ 0.0049
                                        </span>
                                    <span className='price-list'>per Message (US)</span>
                                </div>
                                <div className="feature">
                                     <span className='text-bold'>
                                        30,000
                                        </span>
                                    <span className='price-list'>Free Notifications Monthly</span>
                                </div>
                                <div className="feature">
                                    <span className='text-bold'>
                                        1,000
                                    </span>
                                    <span className='price-list'>Free Messages Monthly</span>
                                </div>
                                <div className="feature">Unlimited</div>
                                <div className="feature">Unlimited</div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-check"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature">2 Months</div>
                                <div className="feature">Basic
                                    <div className="tooltip"> ? <span
                                        className="tooltiptext">Includes 10 shortened links for individual link analytics and performance across all channels in real-time.</span>
                                    </div>
                                </div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                                <div className="feature"><i className="fas fa-times"></i></div>
                            </div>
                            <button className='plan-button'>
                                Start for free
                            </button>
                        </div>
                    </div>
                </div>

                <div id="mobile-screen">
                    <div className="plan-chooser">
                        <div
                            onClick={() => this.selectPlan('enterprise')}
                            className={this.state.chosenPlan === 'enterprise' ? "plan-tab active" : 'plan-tab'}>
                            Enterprise
                        </div>
                        <div
                            onClick={() => this.selectPlan('premium')}
                            className={this.state.chosenPlan === 'premium' ? "plan-tab active" : 'plan-tab'}>
                            Premium
                        </div>
                        <div
                            onClick={() => this.selectPlan('essentials')}
                            className={this.state.chosenPlan === 'essentials' ? "plan-tab active" : 'plan-tab'}>
                            Essentials
                        </div>
                        <div
                            onClick={() => this.selectPlan('free')}
                            className={this.state.chosenPlan === 'free' ? "plan-tab active" : 'plan-tab'}>
                            Free
                        </div>
                    </div>
                    <div className="plans-container">
                        {this.state.chosenPlan === 'free' ?
                            <div id='free-mobile' className="plan">
                                <h2 className="title">
                                    Free
                                </h2>
                                <div className="price-container">
                                    <div className="plan-price">
                                        <span className='currency'>$</span><span className='price'>0</span>
                                        <span className='plan-period'>/month</span>
                                    </div>
                                </div>
                                <div className="feature-rows">
                                    <div className="feature ">
                                        <div className="feature-name feature-sms">
                                            <i className="fas fa-comment-dots"></i>SMS
                                        </div>
                                        <div className="feature-value">
                                         <span className='text-bold'>
                                            $ 0.0149
                                        </span>
                                            <span className='price-list'>per SMS (US)</span>
                                        </div>
                                    </div>
                                    <div className="feature ">
                                        <div className="feature-name feature-viber">
                                            <i className='fab fa-viber'></i> Viber
                                        </div>
                                        <div className="feature-value">
                                        <span className='text-bold'>
                                       $ 0.0049
                                        </span>
                                            <span className='price-list'>per Message (US)</span>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name feature-webpush">
                                            <i className='fas fa-bell'></i> Web Push
                                        </div>


                                        <div className="feature-value">

                    <span className='text-bold'>
                                        30,000
                                        </span>
                                            <span className='price-list'>Free Notifications Monthly</span>
                                        </div>

                                    </div>
                                    <div className="feature  text-center">
                                        <div className="feature-name feature-messenger">
                                            <i className='fab fa-facebook-messenger'></i> Facebook Messenger
                                        </div>
                                        <div className="feature-value">
                   <span className='text-bold'>
                                        1,000
                                    </span>
                                            <span className='price-list'>Free Messages Monthly</span>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-user-check"></i>Unlimited Subscribers
                                        </div>
                                        <div className="feature-value">
                                            <i className="fas fa-check"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fas fa-user-friends'></i> Unlimited Team Members
                                        </div>
                                        <div className="feature-value">
                                            <i className="fas fa-check"></i>

                                        </div>
                                    </div>
                                    <div className="feature feature-button">
                                        <button className='plan-button'>
                                            Start for free
                                        </button>
                                    </div>
                                    <div className="feature features-banner">
                                        Features:
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-chart-pie"></i>
                                            Detailed Analytics
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-check"></i>
                                        </div>
                                    </div>


                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-ad"></i>Ads Manager
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">Create Facebook Messenger Subscriber Acquisition Campaign right from Emitto. </span>
                                            </div>
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-check"></i>
                                        </div>
                                    </div>


                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fab fa-wordpress'></i> Wordpress Plugin
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-check"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fas fa-link'></i> Basic URL Shortener <div
                                            className="tooltip"> ? <span
                                            className="tooltiptext">Includes 100 shortened links for individual link analytics and performance across all channels in real-time.</span>
                                        </div>
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-check"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fas fa-history'></i> Recorded History
                                        </div>
                                        <div className="feature-value text-bold plus-feature">
                                            2 months
                                        </div>
                                    </div>


                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fas fa-compress'></i>Content Curation
                                        </div>
                                        <div className="feature-value text-bold plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className='fas fa-magic'></i>Automations
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">RSS to Web Push - Zero-click Automation. </span>
                                            </div>
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-map-signs"></i>
                                            Dedicated Onboarding
                                        </div>
                                        <div className="feature-value text-bold plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-clipboard-check"></i>Branding Removal
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-fingerprint"></i>Personalized Messages
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-percentage"></i>Volume Discounts
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className='fas fa-times'></i>
                                        </div>
                                    </div>
                                    <div className="feature">
                                        <div className="feature-name">
                                            <i className="fas fa-child"></i>Personal Account Manager
                                        </div>
                                        <div className="feature-value plus-feature">
                                            <i className="fas fa-times"></i>
                                        </div>
                                    </div>

                                </div>
                                <button className='plan-button'>
                                    Start for free
                                </button>
                            </div>
                            :
                            this.state.chosenPlan === 'essentials' ?
                                <div id='essentials-mobile' className="plan">
                                    <img src="img/ribbon.png" className='ribbon' alt="Emitto recommended"/>
                                    <h2 className="title">
                                        Essentials
                                    </h2>
                                    <div className="price-container">
                                        <div className="plan-price">
                                            <div className="yearly-label">
                                                billed annually
                                            </div>
                                            <span className='currency'>$</span><span
                                            className='price'>{this.state.planPeriod === true ? 41 : 49}</span>
                                            <span className='plan-period'>/month</span>
                                        </div>
                                        <div className="choose-period">
                                            <div className="switch-container">
                                                <span>Monthly</span>
                                                <label className="plan-switch" htmlFor="checkbox-3">
                                                    <input
                                                        checked={this.state.planPeriod}

                                                        onClick={this.planPeriodToggle} type="checkbox"
                                                        id="checkbox-3"/>
                                                    <div className="plan-slider plan-round"></div>
                                                </label>
                                                <span>Yearly</span>
                                            </div>
                                        </div>
                                        <div className="feature-rows">
                                            <div className="feature ">
                                                <div className="feature-name feature-sms">
                                                    <i className="fas fa-comment-dots"></i>SMS
                                                </div>
                                                <div className="feature-value">
                       <span className='text-bold'>
                                            $ 0.0139
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>per SMS (US)</span>
                                                </div>
                                            </div>
                                            <div className="feature ">
                                                <div className="feature-name feature-viber">
                                                    <i className='fab fa-viber'></i> Viber
                                                </div>
                                                <div className="feature-value">
                       <span className='text-bold'>
                                            $ 0.0042
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>per Message (US)</span>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name feature-webpush">
                                                    <i className='fas fa-bell'></i> Web Push
                                                </div>
                                                <div className="feature-value ">

                                                    <div className="feature-value">

                            <span className='text-bold'>
                                            $ 0.8
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                        <span className='price-list'>Per 1000 Notifications</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="feature  text-center">
                                                <div className="feature-name feature-messenger">
                                                    <i className='fab fa-facebook-messenger'></i> Facebook Messenger
                                                </div>
                                                <div className="feature-value">
                      <span className='text-bold'>
                                            $ 2.4
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>Per 1000 Messages sent</span>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-user-check"></i>Unlimited Subscribers
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-user-friends'></i> Unlimited Team Members
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>

                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-tag"></i>
                                                    Audience Segmentation
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-compress'></i>Content Curation
                                                </div>
                                                <div className="feature-value text-bold">
                                                    1 Source
                                                </div>
                                            </div>
                                            <div className="feature feature-button">
                                                <button className='plan-button'>
                                                    Start 7 days trial
                                                </button>
                                            </div>
                                            <div className="feature features-banner">
                                                Features:
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-ad"></i>Ads Manager
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">Create Facebook Messenger Subscriber Acquisition Campaign right from Emitto. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fab fa-wordpress'></i> Wordpress Plugin
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-history'></i> Recorded History
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    4 months
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-magic'></i>Automations
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">RSS to Web Push - Zero-click Automation. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-link'></i> Basic URL Shortener <div
                                                    className="tooltip"> ? <span
                                                    className="tooltiptext">Includes 100 shortened links for individual link analytics and performance across all channels in real-time.</span>
                                                </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-map-signs"></i>
                                                    Dedicated Onboarding
                                                    <span className="green-label">promo</span>
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    30 min
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-clipboard-check"></i>Branding Removal
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-fingerprint"></i>Personalized Messages
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-times"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-percentage"></i>Volume Discounts
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className='fas fa-times'></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-child"></i>Personal Account Manager
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-times"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <button className='plan-button'>
                                            Start 7 days trial
                                        </button>
                                    </div>
                                </div>
                                :
                                this.state.chosenPlan === 'premium' ?
                                    <div id='premium-mobile' className="plan">
                                        <h2 className="title">
                                            Premium
                                        </h2>
                                        <div className="price-container">
                                            <div className="plan-price">
                                                <div className="yearly-label">
                                                    billed annually
                                                </div>
                                                <span className='currency'>$</span><span
                                                className='price'>{this.state.planPeriod === true ? 75 : 89}</span>
                                                <span className='plan-period'>/month</span>
                                            </div>
                                        </div>
                                        <div className="choose-period">
                                            <div className="switch-container">
                                                <span>Monthly</span>
                                                <label className="plan-switch" htmlFor="checkbox-1">
                                                    <input
                                                        checked={this.state.planPeriod}

                                                        onClick={this.planPeriodToggle} type="checkbox"
                                                        id="checkbox-1"/>
                                                    <div className="plan-slider plan-round"></div>
                                                </label>
                                                <span>Yearly</span>
                                            </div>
                                        </div>
                                        <div className="feature-rows">
                                            <div className="feature ">
                                                <div className="feature-name feature-sms">
                                                    <i className="fas fa-comment-dots"></i>SMS
                                                </div>
                                                <div className="feature-value">
                   <span className='text-bold'>
                                            $ 0.0132
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>per SMS (US)</span>

                                                </div>
                                            </div>
                                            <div className="feature ">
                                                <div className="feature-name feature-viber">
                                                    <i className='fab fa-viber'></i> Viber
                                                </div>
                                                <div className="feature-value">
                    <span className='text-bold'>
                                            $ 0.0039
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>per Message (US)</span>

                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name feature-webpush">
                                                    <i className='fas fa-bell'></i> Web Push
                                                </div>
                                                <div className="feature-value ">

                                                    <div className="feature-value">

                      <span className='text-bold'>
                                            $ 0.7
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                        <span className='price-list'>per 1000 Notifications</span>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="feature  text-center">
                                                <div className="feature-name feature-messenger">
                                                    <i className='fab fa-facebook-messenger'></i> Facebook Messenger
                                                </div>
                                                <div className="feature-value">
                    <span className='text-bold'>
                                            $ 2.1
                                            <div className="tooltip"> ? <span
                                                className="tooltiptext">
                                            <a href="#">Calculate Your Price</a>
                                                </span>
                                            </div>
                                        </span>
                                                    <span className='price-list'>Per 1000 Messages sent</span>

                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-user-check"></i>Unlimited Subscribers
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-user-friends'></i> Unlimited Team Members
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>

                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-tag"></i>
                                                    Audience Segmentation
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>

                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-fingerprint"></i>Personalized Messages
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-link'></i> Advanced URL Shortener
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">Includes unlimited shortened links with UTM tagging option. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature feature-button">

                                                <button className='plan-button'>
                                                    Start 7 days trial
                                                </button>
                                            </div>
                                            <div className="feature features-banner">
                                                Features:
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-ad"></i>Ads Manager
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">Create Facebook Messenger Subscriber Acquisition Campaign right from Emitto. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fab fa-wordpress'></i> Wordpress Plugin
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-history'></i> Recorded History
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    6 months
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-compress'></i>Content Curation
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    10 Sources
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-magic'></i>Automations
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">RSS to Web Push - Zero-click Automation. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>

                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-map-signs"></i>
                                                    Dedicated Onboarding
                                                    <span className="green-label">promo</span>
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    30 min
                                                </div>
                                            </div>


                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-clipboard-check"></i>Branding Removal
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-percentage"></i>Volume Discounts
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className='fas fa-times'></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-child"></i>Personal Account Manager
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-times"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <button className='plan-button'>
                                            Start 7 days trial
                                        </button>

                                    </div>
                                    :
                                    <div id="enterprise-mobile" className='plan'>
                                        <h2 className="title">Enterprise</h2>
                                        <div className="price-container">

                                            <div className="plan-price">
                                                Contact us
                                            </div>

                                        </div>
                                        <div className="feature-rows">
                                            <div className="feature ">
                                                <div className="feature-name feature-sms">
                                                    <i className="fas fa-comment-dots"></i>SMS
                                                </div>
                                                <div className="feature-value">
                  <span className='text-bold'>
                                        <span
                                            className='text-green'>{"<"}
                                        </span>$ 0.0132
                                    </span>
                                                    <span className='price-list'>per SMS (US)
                                    </span>
                                                </div>
                                            </div>
                                            <div className="feature ">
                                                <div className="feature-name feature-viber">
                                                    <i className='fab fa-viber'></i> Viber
                                                </div>
                                                <div className="feature-value">
                     <span className='text-bold'><span
                         className='text-green'>{"<"}</span>$ 0.0039</span>
                                                    <span className='price-list'>per Message (US)</span>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name feature-webpush">
                                                    <i className='fas fa-bell'></i> Web Push
                                                </div>


                                                <div className="feature-value">

                    <span className='text-bold'><span className='text-bold'><span
                        className='text-green'>{"<"}</span> $ 0.7</span>
                                    </span>
                                                    <span className='price-list'>per 1000 Notifications</span>
                                                </div>

                                            </div>
                                            <div className="feature  text-center">
                                                <div className="feature-name feature-messenger">
                                                    <i className='fab fa-facebook-messenger'></i> Facebook Messenger
                                                </div>
                                                <div className="feature-value">
                   <span className='text-bold'><span className='text-bold'>
                                        <span className='text-green'>{"<"}</span> $ 2.1</span>
                                    </span>
                                                    <span className='price-list'>per 1000 Notifications</span>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-user-check"></i>Unlimited Subscribers
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-user-friends'></i> Unlimited Team Members
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>

                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-tag"></i>
                                                    Audience Segmentation
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-fingerprint"></i>Personalized Messages
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-link'></i> Fully Featured URL Shortener
                                                    <div
                                                        className="tooltip"> ? <span
                                                        className="tooltiptext">Includes 100 shortened links for individual link analytics and performance across all channels in real-time.</span>
                                                    </div>
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>

                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-percentage"></i>Volume Discounts
                                                </div>
                                                <div className="feature-value">
                                                    <i className='fas fa-check'></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-child"></i>Personal Account Manager
                                                </div>
                                                <div className="feature-value">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature feature-button">
                                                <button className='plan-button'>
                                                    Get in touch
                                                </button>
                                            </div>
                                            <div className="feature features-banner">
                                                Features:
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-ad"></i>Ads Manager
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">Create Facebook Messenger Subscriber Acquisition Campaign right from Emitto. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fab fa-wordpress'></i> Wordpress Plugin
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>

                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-history'></i> Recorded History
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    1+ year
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-compress'></i>Content Curation
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    10+ Source
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-magic'></i>Automations
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">RSS to Web Push - Zero-click Automation. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>


                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className='fas fa-magic'></i>Automations
                                                    <div className="tooltip"> ? <span
                                                        className="tooltiptext">RSS to Web Push - Zero-click Automation. </span>
                                                    </div>
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-map-signs"></i>
                                                    Dedicated Onboarding
                                                    <span className="green-label">promo</span>
                                                </div>
                                                <div className="feature-value text-bold plus-feature">
                                                    60+ min
                                                </div>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-name">
                                                    <i className="fas fa-clipboard-check"></i>Branding Removal
                                                </div>
                                                <div className="feature-value plus-feature">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <button className='plan-button'>
                                            Get in touch
                                        </button>
                                    </div>
                        }
                    </div>
                </div>
                <p className='text-center'>Each workspace is billed separately.</p>
            </div>
        );
    }
}

export default Pricing;